import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga4';
import Header from './Header';
import Footer from './Footer';
import DashboardLayout from './layouts/DashboardLayout';

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const location = useLocation();
  
  useEffect(() => {
    ReactPixel.pageView();
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);
  
  if (location.pathname.startsWith('/dashboard')) {
    return <DashboardLayout>{children}</DashboardLayout>;
  }
  
  if (location.pathname.startsWith('/payment/success')) {
    return <>{children}</>;
  }

  if (location.pathname.startsWith('/e/')) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">{children}</main>
      <Footer />
    </div>
  );
}; 